/* eslint-disable react/react-in-jsx-scope */
import {
  AppstoreOutlined,
  BarsOutlined,
  DesktopOutlined,
  GiftOutlined,
  ThunderboltOutlined,
  LogoutOutlined,
  MessageOutlined,
  ProfileOutlined,
  TeamOutlined
} from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ROUTE } from 'src/constants';
import { PAGE_KEYS } from 'src/constants/access';
import { accessDataSelector } from 'src/store/auth';
import { filterMenuItemsByAccess } from 'src/utils';

export const useMenuItems = () => {
  const { t } = useTranslation('menu');
  const access = useSelector(accessDataSelector);

  const MENU_ITEMS = [
    {
      key: ROUTE.DASHBOARD.MAIN,
      icon: <AppstoreOutlined />,
      label: t('dashboard')
    },
    // should be in V2
    // {
    //   key: ROUTE.DASHBOARD.RULES,
    //   icon: <ForkOutlined />,
    //   label: t('rules')
    // },
    {
      key: ROUTE.DASHBOARD.COMMANDS,
      icon: <BarsOutlined />,
      label: t('commands')
    },
    {
      key: ROUTE.DASHBOARD.AUTOMODE,
      icon: <MessageOutlined />,
      label: t('automode')
    },
    {
      key: ROUTE.DASHBOARD.CHAOS,
      icon: <ThunderboltOutlined />,
      label: t('chaos')
    },
    {
      key: ROUTE.DASHBOARD.CHAOS_WIDGET,
      icon: <DesktopOutlined />,
      label: t('chaos_widget')
    },
    {
      key: ROUTE.DASHBOARD.GIVEAWAY,
      icon: <GiftOutlined />,
      label: t('giveaway')
    },
    {
      key: ROUTE.DASHBOARD.GIVEAWAY_EMBED,
      icon: <DesktopOutlined />,
      label: t('giveaway_embed')
    },
    {
      key: ROUTE.DASHBOARD.VIEWERS,
      icon: <TeamOutlined />,
      label: t('viewers')
    },
    {
      key: ROUTE.DASHBOARD.PROFILE,
      icon: <ProfileOutlined />,
      label: t('profile')
    },
    {
      key: ROUTE.DASHBOARD.USERS,
      icon: <TeamOutlined />,
      label: t('users')
    }
  ];

  const ROUTE_TO_PAGE_MAP = {
    [ROUTE.DASHBOARD.MAIN]: PAGE_KEYS.DASHBOARD,
    [ROUTE.DASHBOARD.COMMANDS]: PAGE_KEYS.COMMANDS,
    [ROUTE.DASHBOARD.AUTOMODE]: PAGE_KEYS.AUTOMODE,
    [ROUTE.DASHBOARD.CHAOS]: PAGE_KEYS.CHAOS,
    [ROUTE.DASHBOARD.CHAOS_WIDGET]: PAGE_KEYS.CHAOS_WIDGET,
    [ROUTE.DASHBOARD.GIVEAWAY]: PAGE_KEYS.GIVEAWAY,
    [ROUTE.DASHBOARD.GIVEAWAY_EMBED]: PAGE_KEYS.GIVEAWAY_EMBED,
    [ROUTE.DASHBOARD.VIEWERS]: PAGE_KEYS.VIEWERS,
    [ROUTE.DASHBOARD.PROFILE]: PAGE_KEYS.PROFILE,
    [ROUTE.DASHBOARD.USERS]: PAGE_KEYS.USERS
  };

  const filteredMenuItems = filterMenuItemsByAccess(MENU_ITEMS, access, ROUTE_TO_PAGE_MAP);

  const LOGOUT_ITEMS = [
    {
      key: '/logout',
      icon: <LogoutOutlined />,
      label: t('logout')
    }
  ];

  return { MENU_ITEMS: filteredMenuItems, LOGOUT_ITEMS };
};
